import React from 'react'

interface PaymentSelectorProps {
  payment: { label: string; value: string }
  setPayment: (value: { label: string; value: string }) => void
  paymentMethods: { label: string; value: string }[]
}

const PaymentSelector: React.FC<PaymentSelectorProps> = ({ payment, setPayment, paymentMethods }) => (
  <div className="checkout-page__container-payment_method">
    {paymentMethods.map((item) => (
      <div
        key={item.value}
        className={`checkout-page__container-payment_method-item${item.value === payment.value ? ' active' : ''}`}
        onClick={() => setPayment(item)}
      >
        {item.label}
      </div>
    ))}
  </div>
)

export default PaymentSelector